import React, { FC, ReactElement } from 'react';
import { TableTileCont } from './TableTile.styles';

interface ITableTile {
  children: ReactElement;
  active?: boolean;
  body?: ReactElement;
  isShadowed?: boolean;
}

const TableTile: FC<ITableTile> = ({
  children,
  isShadowed=false,
  body,
  active,
}) => {
  return (
    <TableTileCont id="TableTileCont" isShadowed={isShadowed}>
      {children}
      {active && (<div>{body}</div>)}
    </TableTileCont>
  );
};

export default TableTile;
